import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-success-create-job-dialog',
  templateUrl: './success-create-job-dialog.component.html',
  styleUrls: ['./success-create-job-dialog.component.css', '../success-dialog/success-dialog.component.css']
})
export class SuccessCreateJobDialogComponent implements OnInit {
  id: string;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<SuccessCreateJobDialogComponent>) { }

  ngOnInit() {
    window.dataLayer.push({
      event: 'advertise position',
      eventCategory: 'advertise position',
      eventAction: 'success'
    });
    this.id = this.data.job_id;
  }

  close() {
    this.dialogRef.close();
  }

  redirect() {
    window.open(`${environment.SITE_URL}/job/${this.id}`, '_blank');
  }
}
